import { render } from "./PlacesTopMatter.vue?vue&type=template&id=b312bcfe&ts=true"
import script from "./PlacesTopMatter.vue?vue&type=script&lang=ts"
export * from "./PlacesTopMatter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__